/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { Button, Icon } from 'learning-panel-components';
import { FC } from 'react';
import { getPlatformUrl } from 'utils';
import { translate } from 'translations';
import styles from './skillTreeBanner.module.scss';

const SkillTreeBanner: FC<SkillTreeBannerProps> = (props: SkillTreeBannerProps) => {
    const { name, description, status, uuid, duration } = props;

    return (
        <div>
            <div className={styles['skill-tree-banner']}>
                <div className={styles['inner-wrapper']}>
                    <div className={styles.tag}>{translate(status === 'notStarted' ? 'StartNow' : 'Resume')}</div>
                    <div className={styles['flags-background']}></div>
                    <div className={styles['right-background']}></div>
                    <div className={styles['left-side']}>
                        <div className={styles['top-wrapper']}>
                            <Icon name={'pathThin'} />
                            <div className={styles.text}>
                                {translate('SkillTreeAbout_X_minutes', { minutes: String(duration) })}
                            </div>
                        </div>
                        <div className={styles['name-wrapper']}>
                            <div className={styles.name} title={translate(name)}>
                                {translate(name)}
                            </div>
                        </div>
                        {description && (
                            <div className={styles.description} title={translate(description)}>
                                {translate(description)}
                            </div>
                        )}
                        <div>
                            <div className={styles['button-wrapper']}>
                                <a href={`${getPlatformUrl()}/app/skillTree?uuid=${uuid}`}>
                                    <Button
                                        type="bigGradient"
                                        text={translate(status === 'notStarted' ? 'BeginJourney' : 'Continue')}
                                        className={styles.button}
                                        lowerCase
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export interface SkillTreeBannerProps {
    name: string;
    duration: string;
    description: string;
    uuid: string;
    status: 'inProgress' | 'completed' | 'notStarted';
}

export default SkillTreeBanner;
